import { useEffect, useRef } from 'react';

/**
 * Runs `fn` once per mount, however often the component re-renders or `fn` changes identity.
 * For single-use side effects (consuming a magic-link token): a re-run would be rejected with 401.
 */
export function useRunOnce(fn: () => void): void {
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    fn();
  }, [fn]);
}
